import COLOR from "../../../constants/colors";

const styles = {
  whiteBackground: {
    background: COLOR.white,
    padding: 16,
    marginBottom: 64,
  },
  icon: {
    marginRight: 16,
    fontSize: 24,
  },
  item: {
    marginBottom: 16,
  },
  sider: {
    height: "auto",
    background: "white",
    minHeight: "50vh",
  },
};

export default styles;
